import {setFieldEdition, setFieldVisibility, setSectionCollapsed} from "../../../../../apps/KpModule/actions"
import {fieldsVisibilityRules} from "../utils";
import _ from "lodash";
import {GET_OBJECT_SUCCESS, generateFetchFieldListAction} from "../../../../../apps/KpModule/actions/api";
import moment from "moment/moment";
import {otherActivityFormField, relabelOtherActivityOption} from "../../utils/otherActivity";
import {hasOtherActivity} from "../../staticEntities";

export const module_ = {
    object: 'Adhesion',
    name: 'Application',
    tKey: 'mTitle_adhesionApplication',
    newable: false,
    removable: true,
    objectIdentifier: 'mail',
    category: {
        path: 'menuTitle_adhesion',
        icon: 'idCard'
    },
    formSections: [
        {
            id: 'institutionalSection',
            tKey: 'Volet Institutionnel',
            defaultCollapsed: false,
        },
        {
            id: 'administrativeSection',
            tKey: 'Volet Administratif',
            defaultCollapsed: true,
        },
        {
            id: 'sanitarySection',
            tKey: 'Volet Sanitaire',
            defaultCollapsed: true,
        },
        {
            id: 'visitSection',
            tKey: 'Volet Visite',
            defaultCollapsed: true,
        },
        {
            id: 'decisionSection',
            tKey: 'Volet Décision',
            defaultCollapsed: true,
        },
    ],
    viewMap: {
        dt: [
            {path: 'applicationNumber', tKey: "Référence"},
            {path: 'fullName', tKey: 'chairperson'},
            {path: 'mail', width: 250},
            {path: 'phone', tKey: "mobilePhone"},
            {path: 'organizationName', tKey: "tradingName"},
            {path: 'organizationZipCode', tKey: 'zipCode', initiallyNotVisible: true},
            {path: 'organizationCity', tKey: 'city', initiallyNotVisible: true},
            {path: 'code', tKey: 'N° SIREN'},
            {path: 'status', type: "status", fieldPath: ['id', 'name', 'bStyle'], width: 450},
            {path: 'createdAt', initiallyNotVisible: true},
            {path: 'noDeleteButtonAccess', hidden: true}
        ],
        form: {
            fields: [
                {path: 'applicationNumber', tKey: "Référence", disabled: true},
                {path: 'userSection', section: "institutionalSection", data: "Président(e) de l'association", type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}},

                {path: 'civility', tKey: 'title', section: "institutionalSection", disabled: true},
                {path: 'firstname', section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6", disabled: true},
                {path: 'lastname', section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6",disabled: true},
                {path: 'mail', section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6",disabled: true},
                {path: 'phone', tKey: 'mobilePhone', section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6",type: 'phoneNumber', disabled: true},

                {path: 'organizationSection', section: "institutionalSection", data: 'Association', type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},

                {path: 'organizationName', tKey: "tradingName", disabled: true, section: "institutionalSection"},
                {path: 'code', tKey: 'N° SIREN', disabled: true, widthClassName: "col-xs-12 col-sm-6", section: "institutionalSection"},
                {path: 'publicUtilityRecognition', disabled: true, section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6"},
                {path: 'organizationAddress', tKey: 'address', disabled: true, section: "institutionalSection"},
                {path: 'organizationAdditionalAddress', tKey: 'additionalAddress', disabled: true, section: "institutionalSection"},
                {path: 'organizationZipCode', tKey: 'zipCode', disabled: true, section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6"},
                {path: 'organizationCity', tKey: 'city', disabled: true, section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6"},
                {path: 'organizationCountry', tKey: 'country', disabled: true, section: "institutionalSection"},
                //{path: 'organizationSize', tKey: "Taille de l'association", section: "institutionalSection", disabled: true, sortList: false},
                {path: "sheltersNumber", tKey: "Nombre d'établissements (refuges)", disabled: true, section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6"},
                {path: "animalTypeGroup", tKey: "Groupe d’espèces pris en charge", section: "institutionalSection", disabled: true, widthClassName: "col-xs-12 col-sm-6"},
                /*
                {path: 'generalInterestRecognition', disabled: true, section: "institutionalSection"},
                {path: 'hasEndowmentFund', disabled: true, section: "institutionalSection"},
                {path: 'hasDUERP', disabled: true, section: "institutionalSection"},
                {path: 'DUERPUpdateDate', disabled: true, section: "institutionalSection"},
                 */


                {path: 'documentsSection', data: 'Documents institutionnels', type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true, section: "institutionalSection"},

                {path: 'contactID', tKey: "Pièce d'identité Président(e) de l'association", fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "institutionalSection"},
                {path: 'situationNotice', tKey: 'associationStatusNotice', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "institutionalSection"},
                {path: 'updatedStatus', type: "simpleFiles", fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], disabled: true, section: "institutionalSection"},
                {path: 'balanceSheetsAndIncomeStatements', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "institutionalSection"},
                {path: 'officialStatement', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "institutionalSection"},
                {path: 'CERFA', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "institutionalSection"},
                {path: 'DDPVisitReports', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "institutionalSection"},
                {path: 'lastGeneralMeeting', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "institutionalSection"},

                {path: 'structureSection', section: "administrativeSection", data: "Structure de l'association", type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},

                {path: 'employeesNumber', section: "administrativeSection", tKey: 'employeesNumber_2', disabled: true, required: true, widthClassName: "col-xs-12 col-sm-6"},
                {path: 'electedOfficialsNumber', section: "administrativeSection", tKey: 'electedOfficialsNumber_2', disabled: true, required: true, widthClassName: "col-xs-12 col-sm-6"},
                {path: 'volunteersNumber', section: "administrativeSection", tKey: 'volunteersNumber_2', disabled: true, required: true, widthClassName: "col-xs-12 col-sm-6"},
                {path: 'investigatorsNumber', section: "administrativeSection", tKey: 'investigatorsNumber_2', disabled: true, required: true, widthClassName: "col-xs-12 col-sm-6"},

                {path: 'activitiesSection', section: "administrativeSection", data: "Activités de l'association", type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},

                {path: 'types', section: "administrativeSection", tKey: 'Activités de l’association', disabled: true},
                otherActivityFormField({section: "administrativeSection", disabled: true}),

                {path: 'animalTypes', section: "administrativeSection", tKey: 'animalTypes_2', disabled: true},
                {
                    path: 'adhesionCapacityByAnimalTypeConfigs',
                    tKey: 'adhesionCapacityByAnimalType',
                    type: 'dtObjects',
                    disabled: true,
                    section: 'administrativeSection',
                    fields: [
                        {path: 'animalType', translate: true},
                        {path: 'numberByAnimalType', type: 'editText', dynamic: true}
                    ]
                },

                {path: 'sheltersSection', section: "administrativeSection", data: "Établissement(s) de l'association", type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},

                {
                    path: 'adhesionShelters',
                    section: "administrativeSection",
                    tKey: "Coordonnées",
                    disabled: true,
                    viewMap: {
                        dt: [
                            {path: 'code', tKey: 'siret_spec'},
                            {path: 'status', tKey: 'status'},
                            {path: 'name'},
                            {path: 'zipCode', tKey: 'zipCode_spec'},
                            {path: 'city', tKey: 'city_spec', initiallyNotVisible: true},
                        ],
                        form: [
                            {path: 'code', tKey: 'siret_spec', widthClassName: "col-xs-12 col-sm-6"},
                            {path: 'status', tKey: 'status', widthClassName: "col-xs-12 col-sm-6"},
                            {path: 'name'},
                            {path: 'types', tKey: 'activities_spec'},
                            {path: 'animalTypes', tKey: 'species', display: 'name'},
                            {
                                path: 'adhesionCapacityByActivity',
                                tKey: 'Chiffres produits lors de la dernière assemblée générale',
                                type: 'dtObjects',
                                fields: [
                                    {path: 'animalType', display: 'name', translate: true},
                                    {path: 'ddpp', tKey: 'Capacité agréée DDPP'},
                                    {path: 'totalCapacity', tKey: 'Capacité réelle'},
                                    {path: 'capacityByActivity', type: 'editText', dynamic: true}
                                ]
                            },
                            {path: 'address', tKey: 'address_spec'},
                            {path: 'additionalAddress', tKey: 'additionalAddress_spec'},
                            {path: 'zipCode', tKey: 'zipCode_spec', widthClassName: "col-xs-12 col-sm-6"},
                            {path: 'city', tKey: 'city_spec', widthClassName: "col-xs-12 col-sm-6"},
                            {path: 'shelterSchedules', type: 'textarea'},
                            {path: 'country', tKey: 'country_spec', default: 'France', hidden: true, disabled: true},
                        ]
                    }
                },

                {path: 'documentsSection2', section: "administrativeSection", data: 'Documents administratifs', type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},

                {path: 'bnoDeclarationReceipt', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},
                {path: 'nonCarnivoreSpeciesActivityDeclaration', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},
                {path: 'acacedCertificate', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},
                {path: 'adoptionContractAndCommitmentCertificate', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},
                {path: 'hostFamilyContract', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", disabled: true},
                {path: 'animalEntryExitRegisterExtract', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},
                {path: 'icpeDeclarationDogs', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},
                {path: 'dogWalkSchedule', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},

                {path: 'cerfa15045Receipt', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},

                {path: 'breedingRegister', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},
                {path: 'animalHoldingLocationDeclaration', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},
                {path: 'commitmentAndKnowledgeCertificate', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},
                {path: 'animalWelfareOfficerDeclaration', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},

                {path: 'gdsFarmSummarySheet', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},

                {path: 'openingAuthorizationPrefecture', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},
                {path: 'animalHandlingCapacityCertificate', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},
                {path: 'transportAuthorization', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "administrativeSection"},

                {path: 'documentsSection3', section: "sanitarySection", data: 'Documents sanitaires', type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},

                { path: 'healthRegulationFile', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "sanitarySection" },
                { path: 'veterinarySanitaryDeclaration', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "sanitarySection" },
                { path: 'veterinaryAdoptionCertificate', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "sanitarySection" },
                { path: 'lastVeterinaryVisitReport', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "sanitarySection" },
                { path: 'healthMonitoringRegisterExtract', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "sanitarySection" },
                { path: 'selfInspectionStrategy', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "sanitarySection" },
                { path: 'lastIfceInspectionReport', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "sanitarySection" },
                { path: 'prophylaxisOrDdppExemptionReport', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", disabled: true, section: "sanitarySection" },

                //{path: 'documents', disabled: true, section: "administrativeSection", tKey: 'Documents divers'},


                {path: 'visitors', display: "fullName", tKey: "Personne(s) en charge de la visite", fieldPath: ['id', 'fullName', 'completeInfo'], filters: ['isActive', 'eligibleToVisit'], section: 'visitSection', required: true},
                {path: 'organizationSize', tKey: 'Taille', required: true, section: 'visitSection'},
                {path: 'visitComment', tKey: 'visitComment', type: 'textarea', section: 'visitSection', required: true},
                {path: 'visitReport', tKey: 'Rapport de visite', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: 'visitSection', required: true},

                {path: 'membershipExercise', tKey: 'membershipExercise', required: true, default: {id: 'current', name: 'Exercice en cours'}, section: 'decisionSection'},
                {path: 'amount', tKey: 'adhesionAmount', required: true, widthClassName: "col-xs-12 col-sm-6", section: 'decisionSection'},
                {path: 'paymentDate', tKey: 'paymentDate', section: "decisionSection", endDate: moment().format('YYYY-MM-DD'), required: true, widthClassName: "col-xs-12 col-sm-6"},
                {path: 'paymentMethod', tKey: 'Mode de règlement', section: "decisionSection", required: true, sortList: false, widthClassName: "col-xs-12 col-sm-6"},
                {path: 'functions', tKey: 'jobs_spec', section: "decisionSection", required: true, filters: ['eligibleToAssociation']},
                {path: 'authorizations', tKey: 'profiles_spec', section: "decisionSection", required: true, translateName: true, filters: ['thisModel']},

                {path: 'complementsOrRefusalReason', tKey: 'complementsOrRefusalReason', type: 'textarea'},

                {path: 'followUpSection', data: 'Suivi demande', type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},
                {path: 'conversations', tKey: "Zone d'échanges", section: 'followUpSection'},
                {path: 'status', hidden: true},
                {path: 'buttons', hidden: true}
            ]
        }
    },
    filters: [
        {
            path: 'statuses',
            tKey: 'statut',
            type: 'tags',
            object: 'AdhesionApplicationStatus',
            display: 'name',
            default: [],
            client: true,
            sortList: false,
            query: function(context){
                const statuses = _.get(context, 'data.statuses')
                return !!statuses?.length
                    ? {status: {$in: statuses.map(status => status.id)}}
                    : {}
            },
            width: 12,
        }
    ],
    actionSubscriptions: [
        {
            actionType: GET_OBJECT_SUCCESS,
            subscription: ({ store, module }) => {
                const state = store.getState()
                const statusId = _.get(state, 'edit.object.data.status.id')

                const adhesionShelterTypesList = "m-C-application.AdhesionShelter_types"
                store.dispatch(generateFetchFieldListAction(adhesionShelterTypesList, store.getState))
                    .then(() => relabelOtherActivityOption(store, adhesionShelterTypesList, _.get(state, 'edit.object.data.otherActivity')))
                    .catch(error => console.error('[Adhesion] activity list fetch failed', error))
                const animalTypeGroupId = _.get(state, 'edit.object.data.animalTypeGroup.id')
                const hasShelters = !!_.get(state, 'edit.object.data.sheltersNumber')
                //const hasDUERPValue = _.get(state, 'edit.object.data.hasDUERP')

                //const hasDUERP =  hasDUERPValue && hasDUERPValue.id === 'yes'

                const applicationNumberField = module.viewMap.form.fields.find(field => field.path === "applicationNumber")
                const visitorsField = module.viewMap.form.fields.find(field => field.path === "visitors")
                const visitCommentField = module.viewMap.form.fields.find(field => field.path === "visitComment")
                const visitReportField = module.viewMap.form.fields.find(field => field.path === "visitReport")
                const organizationSizeField = module.viewMap.form.fields.find(field => field.path === "organizationSize")
                const membershipExerciseField = module.viewMap.form.fields.find(field => field.path === "membershipExercise")
                const amountField = module.viewMap.form.fields.find(field => field.path === "amount")
                const paymentDateField = module.viewMap.form.fields.find(field => field.path === "paymentDate")
                const paymentMethodField = module.viewMap.form.fields.find(field => field.path === "paymentMethod")
                const functionsField = module.viewMap.form.fields.find(field => field.path === "functions")
                const authorizationsField = module.viewMap.form.fields.find(field => field.path === "authorizations")
                const complementsOrRefusalReasonField = module.viewMap.form.fields.find(field => field.path === "complementsOrRefusalReason")
                //const DUERPUpdateDateField = module.viewMap.form.fields.find(field => field.path === "DUERPUpdateDate" )

                const handledFields = new Set();

                // Section visibility based on status
                const visibleSections = new Set();
                const sectionStatusMap = {
                    institutionalSection: ['filed', 'incomplete', 'updated', 'preValidated', 'filed2', 'incomplete2', 'updated2', 'validated2', 'filed3', 'incomplete3', 'updated3', 'completed', 'visitInProgress', 'visitValidated', 'visitRejected', 'accepted', 'rejected', 'validated'],
                    administrativeSection: ['filed2', 'incomplete2', 'updated2', 'validated2', 'filed3', 'incomplete3', 'updated3', 'completed', 'visitInProgress', 'visitValidated', 'visitRejected', 'accepted', 'rejected', 'validated'],
                    sanitarySection: ['filed3', 'incomplete3', 'updated3', 'completed', 'visitInProgress', 'visitValidated', 'visitRejected', 'accepted', 'rejected', 'validated'],
                    decisionSection: ['visitValidated', 'visitRejected', 'accepted', 'validated'],
                    followUpSection: ['filed', 'incomplete', 'updated', 'preValidated', 'filed2', 'incomplete2', 'updated2', 'validated2', 'filed3', 'incomplete3', 'updated3', 'completed', 'visitInProgress', 'visitValidated', 'visitRejected', 'accepted', 'validated'],
                };
                Object.entries(sectionStatusMap).forEach(([section, statuses]) => {
                    if (statuses.includes(statusId)) visibleSections.add(section)
                });

                const setVisible = (fieldId, section, condition) => {
                    const visible = visibleSections.has(section) && condition
                    store.dispatch(setFieldVisibility(fieldId, visible))
                    handledFields.add(fieldId)
                };

                store.dispatch(setFieldVisibility(applicationNumberField.id, true))
                handledFields.add(applicationNumberField.id)

                // visitSection fields visibility and edition rules (visibility is handled by section fallback)
                store.dispatch(setFieldVisibility(visitorsField.id, ['completed', 'visitInProgress', 'visitValidated', 'visitRejected', 'accepted', 'rejected', 'validated'].includes(statusId)))
                handledFields.add(visitorsField.id)
                store.dispatch(setFieldEdition(visitorsField.id, "completed" === statusId))

                store.dispatch(setFieldVisibility(visitCommentField.id, ['visitInProgress', 'visitValidated', 'visitRejected', 'accepted', 'rejected', 'validated'].includes(statusId)))
                handledFields.add(visitCommentField.id)
                store.dispatch(setFieldEdition(visitCommentField.id, "visitInProgress" === statusId))

                store.dispatch(setFieldVisibility(visitReportField.id, ['visitInProgress', 'visitValidated', 'visitRejected', 'accepted', 'rejected', 'validated'].includes(statusId)))
                handledFields.add(visitReportField.id)
                store.dispatch(setFieldEdition(visitReportField.id, "visitInProgress" === statusId))

                store.dispatch(setFieldVisibility(organizationSizeField.id, ['completed', 'visitInProgress', 'visitValidated', 'visitRejected', 'accepted', 'rejected', 'validated'].includes(statusId)))
                handledFields.add(organizationSizeField.id)

                //store.dispatch(setFieldVisibility(DUERPUpdateDateField.id,  sectionStatusMap.institutionalSection.includes(statusId) && hasDUERP))
                //handledFields.add(DUERPUpdateDateField.id)

                // decisionSection: membershipExercise, amount & paymentDate visible only at accepted/validated
                store.dispatch(setFieldVisibility(membershipExerciseField.id, ['accepted', 'validated'].includes(statusId)))
                handledFields.add(membershipExerciseField.id)
                store.dispatch(setFieldVisibility(amountField.id, ['accepted', 'validated'].includes(statusId)))
                handledFields.add(amountField.id)
                store.dispatch(setFieldVisibility(paymentDateField.id, ['accepted', 'validated'].includes(statusId)))
                handledFields.add(paymentDateField.id)
                store.dispatch(setFieldVisibility(paymentMethodField.id, ['accepted', 'validated'].includes(statusId)))
                handledFields.add(paymentMethodField.id)
                store.dispatch(setFieldVisibility(functionsField.id, ['accepted', 'validated'].includes(statusId)))
                handledFields.add(functionsField.id)
                store.dispatch(setFieldVisibility(authorizationsField.id, ['accepted', 'validated'].includes(statusId)))
                handledFields.add(authorizationsField.id)

                // complementsOrRefusalReason: visible when adjourn or reject buttons are displayed
                store.dispatch(setFieldVisibility(complementsOrRefusalReasonField.id, ['filed', 'updated', 'filed2', 'updated2', 'filed3', 'updated3', 'visitValidated', 'visitRejected'].includes(statusId)))
                handledFields.add(complementsOrRefusalReasonField.id)

                // decisionSection field edition rules (visibility is handled above or by section fallback)
                store.dispatch(setFieldEdition(organizationSizeField.id, "completed" === statusId))
                store.dispatch(setFieldEdition(membershipExerciseField.id, ['accepted'].includes(statusId)))
                store.dispatch(setFieldEdition(amountField.id, ['accepted'].includes(statusId)))
                store.dispatch(setFieldEdition(paymentDateField.id, ['accepted'].includes(statusId)))
                store.dispatch(setFieldEdition(paymentMethodField.id, ['accepted'].includes(statusId)))
                store.dispatch(setFieldEdition(functionsField.id, ['accepted'].includes(statusId)))
                store.dispatch(setFieldEdition(authorizationsField.id, ['accepted'].includes(statusId)))

                // Section collapse rules
                store.dispatch(setSectionCollapsed('institutionalSection', !['filed', 'incomplete', 'updated'].includes(statusId)))
                store.dispatch(setSectionCollapsed('administrativeSection', !['filed2', 'incomplete2', 'updated2'].includes(statusId)))
                store.dispatch(setSectionCollapsed('sanitarySection', !['filed3', 'incomplete3', 'updated3'].includes(statusId)))
                store.dispatch(setSectionCollapsed('visitSection', !['completed', 'visitInProgress'].includes(statusId)))
                store.dispatch(setSectionCollapsed('decisionSection', !['visitValidated', 'visitRejected', 'accepted'].includes(statusId)))

                // Apply field-specific visibility rules
                const fileRules = fieldsVisibilityRules(animalTypeGroupId, hasShelters, hasOtherActivity(_.get(state, 'edit.object.data.types')));
                fileRules.forEach(({ id, section, condition }) => {
                    setVisible(id, section, condition)
                })

                // Fallback: section-wide visibility for other fields
                module.viewMap.form.fields.forEach(field => {
                    if (!handledFields.has(field.id)) {
                        const show = visibleSections.has(field.section)
                        store.dispatch(setFieldVisibility(field.id, show))
                    }
                })
            }
        }
    ]
}
